import { ActionMap } from "library/ActionMap";
import {
  ApiError,
  FullAddress,
  UpdateAddressResponse,
} from "library/api/address/types.generated";
import { components } from "library/api/card-management-service.generated";
import { ResidentialFormValues } from "pages/ManagePersonalDetails/types";

export type InternalState =
  | {
      status: "IDLE";
    }
  | {
      status: "2FA_REQUIRED";
      createSessionUrl: string;
      token: string;
    }
  | {
      status: "ERROR";
      error?: ApiError | string;
    }
  | {
      status: "SUCCESS";
      payload: ApiData;
    };

export type ApiData = {
  residential: {
    status: components["schemas"]["UpdateAddressResponse"]["status"];
    address?: FullAddress;
  };
  mailing: {
    status:
      | components["schemas"]["UpdateAddressResponse"]["status"]
      | "NOT_REQUIRED";
  };
};

export type MailingApiData = {
  status: components["schemas"]["UpdateAddressResponse"]["status"];
  address: FullAddress;
};

export enum ActionTypes {
  SUBMIT_ISSUES = "SUBMIT_ISSUES",
  SUBMIT_ERROR = "SUBMIT_ERROR",
  SUBMIT_SUCCESS = "SUBMIT_SUCCESS",
  SUBMIT_2FA_REQUIRED = "SUBMIT_2FA_REQUIRED",
  LOAD_WITH_2AF_RENEWED = "LOAD_WITH_2AF_RENEWED",
}

export type Payloads = {
  [ActionTypes.SUBMIT_ISSUES]: {
    payload: {
      apiError: ApiError;
      formValues: ResidentialFormValues;
    };
  };
  [ActionTypes.SUBMIT_ERROR]: {
    payload: {
      apiError?: ApiError;
    };
  };
  [ActionTypes.SUBMIT_2FA_REQUIRED]: {
    payload: { createSessionUrl?: string; token?: string };
  };
  [ActionTypes.SUBMIT_SUCCESS]: {
    payload: {
      apiData: UpdateAddressResponse;
      formValues: ResidentialFormValues;
    };
  };
};

export type Actions = ActionMap<ActionTypes, Payloads>;
